<template>
  <div class="forgot-username-component">
    <a-button type="link" class="back-button" ghost @click="onCancelClick">
      <chevron-left-icon></chevron-left-icon>
      Terug
    </a-button>
    <h2 class="title color-white pb-md">
      Gebruikersnaam vergeten
    </h2>
    <div v-if="!requestedUsernameReminder">
      <p class="color-white mb-xs">E-mailadres</p>
      <p class="mb-md">
        <a-input type="email" ref="username" v-model="emailaddress"
                 v-on:keyup.enter.native.prevent="onRequestUsernameReminderClick"
                 v-bind:class="{'has-error': !emailValid}"
                 @focus="() => {emailValid = true}"
                 @blur="validateEmail"
        />
      </p>
      <p class="color-white pb-md">
        We sturen je een mail met je gebruikersnaam.
      </p>
      <p>
        <a-button :loading="requestingUsernameReminder" size="large" type="primary" block
                  @click="onRequestUsernameReminderClick">
          Gebruikersnaam opvragen
        </a-button>
      </p>
    </div>
    <div v-if="requestedUsernameReminder">
      <p class="color-white">
        Klopt het ingevoerde e-mailadres?
      </p>
      <p class="color-white">
        Dan hebben we je een mail gestuurd met daarin je gebruikersnaam.
      </p>
      <br/>
      <p class="color-white">
        Weet je niet zeker of het jou opgegeven e-mailadres klopt, neem dan contact op met
        info@dossierdata.nl
      </p>
    </div>
  </div>
</template>
<script>
import authApi from "~/api/auth";
import ForgotPasswordComponent from "./ForgotPasswordComponent";
export default {
  name: "ForgotUsernameComponent",
  props: {},
  data() {
    return {
      emailaddress: '',
      requestedUsernameReminder: false,
      requestingUsernameReminder: false,
      emailValid: true,
    }
  },
  computed: {},
  methods: {
    validateEmail(e) {
      let emailRegex = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      this.emailValid = (
          (this.emailaddress.length > 0)
          && emailRegex.test(this.emailaddress)
      );
    },
    onRequestUsernameReminderClick() {
      if (!this.emailValid) {
        this.$notification['error']({
          message: 'Het ingevoerde e-mailadres is niet geldig',
        });
        return false;
      }
      this.requestingPasswordReset = true;
      authApi.requestUsernameReminder(this.emailaddress)
          .then(this.handleUsernameSuccess, this.handleUsernameReminderError);
    },
    onCancelClick() {
      this.$emit('cancel');
    },
    handleUsernameSuccess() {
      this.requestingUsernameReminder = false;
      this.requestedUsernameReminder = true;
      this.$emit('success');
    },
    handleUsernameReminderError(error) {
      this.requestingUsernameReminder = false;
      this.requestedUsernameReminder = false;
      this.$notification['error']({
        message: 'Er is iets fout gegaan',
      });
    }
  },
  mounted() {
    this.username = this.defaultUsername;
    this.rememberUsername = this.defaultRememberUsername;
    setTimeout(() => {
      if (this.defaultRememberUsername) {
        this.$refs.password.focus();
      } else {
        this.$refs.username.focus();
      }
    }, 500);
  }
}
</script>
<style lang="scss" scoped>
.auth-panel {
  background-color: #1a4b6c;
  color: white;
}
.side-image {
  background-size: cover;
  background-position: center left;
}
.auth-panel .content {
  padding: 3rem 4rem;
  min-height: 35rem;
}
.forgot-username-component .title {
  font-size: 3rem !important;
  color: white !important;
}
.auth-panel .steps {
  margin: -1rem 0rem 1rem 0rem;
  color: rgba(255, 255, 255, 0.5);
}
.auth-panel .steps .active {
  color: white;
}
.forgot-username-component .back-button {
  margin-left: -18px;
  margin-bottom: 18px;
}
.has-error {
  border-color: #ff4040;
  box-shadow: 0 0 0 2px rgba(255, 24, 24, 0.2);
}
</style>
